/* Dynamic cart upsell: shows a product the visitor viewed this session
   (excluding anything already in cart); falls back to the newest arrival
   if there is no eligible viewed product. Falls back to the merchant's
   static section-configured product (already server-rendered) if anything
   here fails or returns nothing. */
(function () {
  'use strict';

  var STORAGE_KEY = 'dcv_session_viewed_products';
  var NEWEST_COLLECTION_HANDLE = 'internal-all-products-newest';

  var LABELS = {
    'zh-TW': { buy: '立即購買', view: '查看產品' },
    'ja': { buy: '今すぐ購入', view: '製品を表示' },
    'ko': { buy: '지금 구매하기', view: '상품 보기' }
  };

  function localePrefix() {
    var m = window.location.pathname.match(/^\/(ja-jp|ko)(\/|$)/);
    return m ? '/' + m[1] : '';
  }

  function labelSet() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (lang.indexOf('ja') === 0) return LABELS.ja;
    if (lang.indexOf('ko') === 0) return LABELS.ko;
    return LABELS['zh-TW'];
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (!format) return '$' + value;
    if (format.indexOf('{{amount_no_decimals}}') !== -1) {
      return format.replace('{{amount_no_decimals}}', Math.round(cents / 100));
    }
    return format.replace('{{amount}}', value);
  }

  function withWidth(url, width) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  async function safeFetchJson(url) {
    try {
      var res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  async function fetchProduct(prefix, handle) {
    if (!handle) return null;
    return await safeFetchJson(prefix + '/products/' + handle + '.js');
  }

  async function getCartProductIds(prefix) {
    var cart = await safeFetchJson(prefix + '/cart.js');
    var ids = new Set();
    if (cart && cart.items) {
      cart.items.forEach(function (item) { ids.add(item.product_id); });
    }
    return ids;
  }

  function getSessionViewed(cartProductIds) {
    var list = [];
    try { list = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) { list = []; }
    return list
      .filter(function (p) { return p && p.handle && !cartProductIds.has(p.id); })
      .sort(function (a, b) { return (b.ts || 0) - (a.ts || 0); });
  }

  async function pickCandidateProduct(prefix, cartProductIds) {
    var viewed = getSessionViewed(cartProductIds);
    for (var i = 0; i < viewed.length; i++) {
      var p = await fetchProduct(prefix, viewed[i].handle);
      if (p && p.available && !cartProductIds.has(p.id)) return p;
    }

    var newest = await safeFetchJson(prefix + '/collections/' + NEWEST_COLLECTION_HANDLE + '/products.json?limit=10');
    if (newest && newest.products) {
      for (var j = 0; j < newest.products.length; j++) {
        var item = newest.products[j];
        if (cartProductIds.has(item.id)) continue;
        var full = await fetchProduct(prefix, item.handle);
        if (full && full.available) return full;
      }
    }

    return null;
  }

  function buildMarkup(product, prefix) {
    var labels = labelSet();
    var href = prefix + product.url;
    var imgSrc = withWidth(product.featured_image, 280);
    var moneyFormat = (window.KROWN && window.KROWN.settings && window.KROWN.settings.shop_money_format) || '${{amount}}';
    var priceHtml = formatMoney(product.price, moneyFormat);
    var compareHtml = '';
    if (product.compare_at_price && product.compare_at_price > product.price) {
      compareHtml = formatMoney(product.compare_at_price, moneyFormat);
    }
    var isSingleVariant = product.variants.length === 1;

    var actionHtml;
    if (!product.available) {
      actionHtml = '';
    } else if (isSingleVariant) {
      actionHtml =
        '<quick-add-to-cart class="quick-add-to-cart">' +
          '<product-form data-ajax-cart>' +
            '<div class="quick-add-to-cart-button">' +
              '<form method="post" action="' + prefix + '/cart/add" enctype="multipart/form-data">' +
                '<input type="hidden" name="id" value="' + product.variants[0].id + '">' +
                '<button id="cart-upsell-add-to-cart" class="add-to-cart button button--small button--outline--hover-accent button--loader" type="submit" name="add" data-js-product-add-to-cart>' +
                  '<span class="button__text">' + labels.buy + '</span>' +
                  '<span class="button__loader"></span>' +
                '</button>' +
              '</form>' +
            '</div>' +
          '</product-form>' +
        '</quick-add-to-cart>';
    } else {
      actionHtml =
        '<a class="button button--small button--outline--hover-accent" href="' + href + '">' +
          '<span class="button__text">' + labels.view + '</span>' +
        '</a>';
    }

    return (
      '<div class="cart-item cart-individual-product-recommendation" data-js-product-item>' +
        '<a href="' + href + '" class="cart-item__thumbnail">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="140" height="140" style="object-fit:cover">' : '') +
        '</a>' +
        '<div class="cart-item__content sidebar__inner-element">' +
          '<div>' +
            '<a href="' + href + '" class="cart-item__title text-size--16">' +
              '<span class="text-animation--underline"><span>' + escapeHtml(product.title) + '</span></span>' +
            '</a>' +
            '<div class="cart-item__price text-size--16">' +
              '<div class="product-price">' +
                '<span class="product-price--original pps" data-js-product-price-original>' + priceHtml + '</span>' +
                '<del class="product-price--compare" data-js-product-price-compare>' + compareHtml + '</del>' +
              '</div>' +
            '</div>' +
            actionHtml +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function attachScrollBehaviour() {
    var btn = document.getElementById('cart-upsell-add-to-cart');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (document.getElementById('site-cart-sidebar')) {
        setTimeout(function () {
          var container = document.querySelector('#site-cart-sidebar .sidebar__container');
          if (container) container.scrollTo({ top: 0, behavior: 'smooth' });
        }, 150);
      }
    });
  }

  var running = false;
  var pendingRerun = false;

  async function refreshUpsell() {
    if (running) { pendingRerun = true; return; }
    running = true;
    try {
      var slot = document.getElementById('cart-upsell-product-slot');
      if (!slot) return;

      var prefix = localePrefix();
      var cartProductIds = await getCartProductIds(prefix);
      var product = await pickCandidateProduct(prefix, cartProductIds);
      if (!product) return; // keep the merchant-configured static fallback already rendered

      slot.innerHTML = buildMarkup(product, prefix);
      attachScrollBehaviour();
    } catch (e) {
      /* leave static fallback in place */
    } finally {
      running = false;
      if (pendingRerun) {
        pendingRerun = false;
        refreshUpsell();
      }
    }
  }

  function init() {
    var block = document.getElementById('cart-upsell-block');
    if (!block) return;

    refreshUpsell();

    var cartForm = document.getElementById('AjaxCartForm');
    if (cartForm) {
      var debounceTimer = null;
      new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(refreshUpsell, 400);
      }).observe(cartForm, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
